import { colors, FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  container: FelaCSS;
  imgBox: FelaCSS;
  img: FelaCSS;
  favorite: FelaCSS;
  featuredMarkerWrap: FelaCSS;
  title: FelaCSS;
  review: FelaCSS;
  count: FelaCSS;
  price: FelaCSS;
}

const styles = (): IStyles => ({
  container: {
    width: '100%',
  },
  imgBox: {
    height: 176,
    borderRadius: 14,
    position: 'relative',
    overflow: 'hidden',

    maxWidthTabletSm: {
      height: 215,
    },
  },
  img: {
    width: '100%',
    height: '100%',
    position: 'relative',
    objectFit: 'cover',
    zIndex: -1,
  },
  favorite: {
    position: 'absolute',
    width: 38,
    height: 38,
    background: 'white',
    borderRadius: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    top: 10,
    right: 10,
    border: `1px solid ${colors.space04}`,
  },
  featuredMarkerWrap: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
  },
  title: {
    margin: `${spacing[2]} ${spacing[0]} ${spacing[0]}`,
    color: colors.space,
    fontDefaultSemiBold: 14,
    lineHeight: '130%',
  },
  review: {
    flexDirection: 'row',
    alignItems: 'center',
    color: colors.space75,
    fontDefault: 12,
    marginVertical: spacing[1],
  },
  count: {
    marginLeft: 1,
  },
  price: {
    color: colors.space,
    fontDefault: 12,
  },
});

export default styles;
